export default "__VITE_ASSET__q6gxv$yT__"